import API from '../../../../services/api';

export const getPosts = async () => {
    return await API.get('/blog').then(res => res.data);
};

export const getPost = async (slug) => {
    return await API.get('/blog/' + slug).then(res => res.data);
};
